import React from 'react'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_EXISTENCIA_DIARIA } from '../../../config/tables'

function ExistenciaDiariaPorCereal () {
  return (
    <MuiTable id={TABLA_EXISTENCIA_DIARIA} />
  )
}

export default ExistenciaDiariaPorCereal
